var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "member-app-container",
      staticStyle: { position: "relative", height: "100%" },
    },
    [
      _c("el-alert", {
        attrs: { title: "預設角色為TC-USER", type: "success", closable: false },
      }),
      _c("member-data", { attrs: { pageRoles: _vm.roles, title: _vm.title } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }